import { FormSection, JsonItem } from "../../../../shared/components/web-form/web-form.objects";
import { CppForm } from "../../../../shared/entities/cpp-form/cpp-form";
import { CppProposalFormNavigation } from './cpp-proposal-form.navigation';
import { plainToClass } from "class-transformer";
import _ from "lodash";
import { DataViewer, DataViewType } from "../../../../shared/components/edit-table/data-viewer";
import { ViewModalTable } from "../../../../shared/components/edit-table/view-modal";
import { TextInputFieldV1 } from "../../../../shared/components/web-form/form-field/v1/text-input";
import { DropdownInputFieldV1, DropdownInputV1Options } from "../../../../shared/components/web-form/form-field/v1/dropdown-input";
import { FileUploadInputFieldV1, FileUploadInputV1Options } from "../../../../shared/components/web-form/form-field/v1/file-upload-input";

export class CppProposalForm  {
    formSections: FormSection[]; 
    pickLists: JsonItem[];
    currentItem: CppForm; 
    defaultItem: CppForm; 

    navigation: CppProposalFormNavigation;

    sideBarElement: JQuery<HTMLElement>;
    formElement: JQuery<HTMLElement>;
    confirmSubmitModal: JQuery<HTMLElement>;

    saveRoute: string;
    submitRoute: string;
    redirectRoute: string;

    saveBtn: JQuery<HTMLElement>;
    saveBtnLoading: JQuery<HTMLElement>;
    saveBtnComplete: JQuery<HTMLElement>;
    submitBtn: JQuery<HTMLElement>;
    submitBtnContainer: JQuery<HTMLElement>;
    submitBtnLoading: JQuery<HTMLElement>;

    isSaving: boolean = false;

    reviewId: string = "form-review-container";
    reviewTables: ViewModalTable[];


    constructor(currentForm: CppForm, pickLists: JsonItem[]) {
        this.currentItem = currentForm;
        this.defaultItem = CppForm.getDefault();
        this.pickLists = pickLists;

        this.sideBarElement = $(".sidebar-container");
        this.formElement = $(".cpp-form");
        this.confirmSubmitModal = $("#confirm-submit-modal");

        this.saveRoute = "/secure/cpp/cpp-proposal-form/cpp-proposal-form?handler=SaveForm";
        this.submitRoute = "/secure/cpp/cpp-proposal-form/cpp-proposal-form?handler=SubmitForm";
        this.redirectRoute = "/secure/cpp-proposal-submit";

        this.formSections = [
            new FormSection({
                displayName: "Proposal Overview",
                sectionId: "proposal-overview",
                formFields: [
                    new TextInputFieldV1("ProjectTitle", "project-title", "CPP Title", "", true),
                    new DropdownInputFieldV1("LeadHubId", "lead-hub-select", "Lead Hub", "", true, new DropdownInputV1Options("pl-hub", false)),
                    new DropdownInputFieldV1("CollaboratingHubIds", "collab-hub-select", "Collaborating Hubs", "", true, new DropdownInputV1Options("pl-hub", true)),
                    new DropdownInputFieldV1("CommunicateUpdatesIds", "communicate-with-select", "Communicate Updates With", "", false, new DropdownInputV1Options("pl-user", true, true))
                ]
            }),
            new FormSection({
                displayName: "Proposal Upload",
                sectionId: "proposal-upload",
                formFields: [
                    new FileUploadInputFieldV1("ProposalUploadId", "proposal-upload-container", "Proposal Upload", "", true, new FileUploadInputV1Options("CppForm/ProposalUploadId", false, true))
                ]
            })
        ];

        this.reviewTables = [
            new ViewModalTable("CPP Proposal Information", [
                new DataViewer("ProjectTitle", DataViewType.String, "CPP Title"),
                new DataViewer("AppUserId", DataViewType.NumberId, "Submitter", "pl-user"),
                new DataViewer("LeadHubId", DataViewType.NumberId, "Lead Hub", "pl-hub"),
                new DataViewer("CollaboratingHubIds", DataViewType.PipePathSeparatedBullets, "Collaborating Hubs", "pl-hub"),
                new DataViewer("CommunicateUpdatesIds", DataViewType.PipePathSeparatedBullets, "Communicate Updates With", "pl-user"),
            ]),
            new ViewModalTable("CPP Proposal Upload", [
                new DataViewer("ProposalUploadId", DataViewType.DocumentUpload, "Uploaded PDF", "", "CppForm/ProposalUploadId")
            ])
        ];

        this.reviewTables.forEach(table => table.initialize(this.pickLists));

        this.initialize();

        this.sideBarElement.removeClass("d-none");
        this.formElement.removeClass("d-none");
    }

    initialize() {
        this.formSections.forEach(section => section.initialize(this.pickLists));
        this.prepopulateForm();

        this.navigation = new CppProposalFormNavigation(this);
        this.navigation.initialize();
        this.updateAllNavSections();
        this.initializeSaveSubmitBtns();

        this.formElement.off("form-field-change").on("form-field-change", () => {
            this.updateAllNavSections();
        })
    }

    private prepopulateForm() {
        let formObj = _.cloneDeep(this.currentItem);

        this.formSections.forEach(section => {
            section.formFields.forEach(field => {
                field.prepopulate([formObj]);
            })
        })
    }

    private initializeSaveSubmitBtns() {
        // Save Btn (Partial Save)
        this.saveBtn = this.sideBarElement.find(".save-progress-btn");
        this.saveBtnLoading = this.sideBarElement.find(".save-form-loading");
        this.saveBtnComplete = this.sideBarElement.find(".save-form-complete");

        this.saveBtn.on("click", () => {
            this.triggerSave();
        });

        this.submitBtn = this.confirmSubmitModal.find("#submit-button");
        this.submitBtnContainer = this.confirmSubmitModal.find(".submit-btn-container");
        this.submitBtnLoading = this.confirmSubmitModal.find(".submit-btn-loading");

        this.submitBtn.on("click", () => {
            this.triggerSubmit();
        })
    }

    async triggerSave() {
        if (this.isSaving) {
            return;
        }
        this.saveBtn.addClass('d-none');
        this.saveBtnLoading.removeClass('d-none');

        await this.saveForm();

        this.saveBtnLoading.addClass("d-none");
        this.saveBtnComplete.removeClass('d-none');

        setTimeout(() => {
            this.saveBtnComplete.addClass("d-none");
            this.saveBtn.removeClass("d-none");
        }, 1500)
    }

    async triggerSubmit() {
        if (this.isSaving) {
            return;
        }
        this.submitBtnContainer.addClass('d-none');
        this.submitBtnLoading.removeClass("d-none");

        let result = await this.submitForm();

        let origin = window.location.origin
        let targetUrl = `${origin}${this.redirectRoute}`;

        window.location.href = targetUrl; // Redirect to submit page
    }

    private updateAllNavSections() {
        this.formSections.forEach(section => {
            let status = section.getSectionStatus();
            this.navigation.updateSectionStatus(section.sectionId, status);
        })
    }

    async saveForm(): Promise<any> {
        if (this.isSaving) {
            return;
        }

        this.isSaving = true;
        let formObj = _.cloneDeep(this.currentItem);

        // Update Form
        this.formSections.forEach(section => {
            section.formFields.forEach(field => {
                formObj = field.updateItem(formObj);
            })
        })

        let result: any;
        try {
            result = await $.ajax(this.saveRoute, {
                method: "POST",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify(formObj) }
            });

            if (this.currentItem.Id == 0) {
                let updatedForm = plainToClass(CppForm, <CppForm>result);
                if (updatedForm.Id > 0) {
                    this.currentItem.Id = updatedForm.Id
                }
            }

            this.isSaving = false;
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async submitForm(): Promise<any> {
        if (this.isSaving) {
            return;
        }

        this.isSaving = true;
        let formObj = _.cloneDeep(this.currentItem);

        // Update Form
        this.formSections.forEach(section => {
            section.formFields.forEach(field => {
                formObj = field.updateItem(formObj);
            });
        })

        let result: any;
        try {
            result = await $.ajax(this.submitRoute, {
                method: "POST",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify(formObj) }
            });
            this.isSaving = false;
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    updateReviewContent() {
        let formObj = _.cloneDeep(this.currentItem);
        // Update Form
        this.formSections.forEach(section => {
            section.formFields.forEach(field => {
                formObj = field.updateItem(formObj);
            });
        })

        let content = "";
        this.reviewTables.forEach(table => {
            let tableHtml = table.generateTableHtml(formObj);
            content += tableHtml;
        });

        $(`#${this.reviewId}`).empty().html(content);

        // Initialize documents (if present)
        this.reviewTables.forEach(table => {
            table.dataViewArray.forEach(view => {
                if (view.propertyType == DataViewType.DocumentUpload) {
                    view.getDocuments(formObj);
                }
            })
        });
    }
}
